const ownLink = "https://opimisil.com/PbMQ96yF";

const blogs = [
  {
    id: 1,
    date: "2025-01-14",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "Jak maximalizovat své šance na výhru v doxxbet casino",
    descr: "Objevte tipy a strategie pro úspěšné hraní na doxxbet.cz.",
    fullText:
      "Hraní v kasinu může být nejen zábavné, ale i výdělečné, pokud zvolíte správný přístup.\n" +
      "Začněte tím, že se seznámíte s pravidly her, které vás zajímají. Znalost pravidel je základem úspěchu.\n" +
      "Stanovte si rozpočet pro hraní a držte se ho. Hraní zodpovědně je klíčové.\n" +
      "Využijte bonusy a promo akce, které doxxbet nabízí. Pomohou vám zvýšit vaše šance na výhru.\n" +
      "Experimentujte s různými hrami, abyste zjistili, která vám nejvíce vyhovuje.\n" +
      "Sledujte statistiky a analýzy, které vám mohou pomoci lépe pochopit dynamiku her.\n" +
      "Pamatujte, že štěstí hraje svou roli, ale chytrá strategie vám může pomoci.\n" +
      "Hrajte pro zábavu, ne jen pro výhru, a užívejte si každý moment na doxxbet.cz.",
  },
  {
    id: 2,
    date: "2025-01-10",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Výhody sportovního sázení na doxxbet",
    descr: "Zjistěte, proč je doxxbet nejlepší volbou pro sportovní sázkaře.",
    fullText:
      "Sportovní sázení je stále populárnější a doxxbet nabízí ideální platformu pro vaše sázky.\n" +
      "Na doxxbet najdete širokou nabídku sportů od fotbalu po tenis.\n" +
      "Sázky live vám umožní reagovat na aktuální průběh zápasů.\n" +
      "Vysoké kurzy zajišťují, že dostanete maximální hodnotu za své sázky.\n" +
      "Bezpečnost je pro nás prioritou, vaše údaje jsou chráněny.\n" +
      "Naše mobilní aplikace vám umožní sázet kdykoliv a kdekoliv.\n" +
      "Speciální bonusy a promo akce zvyšují vaše šance na výhru.\n" +
      "Přidejte se k tisícům spokojených uživatelů a zažijte zábavu na doxxbet.cz.",
  },
  {
    id: 3,
    date: "2025-01-05",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "Proč si stáhnout aplikaci doxxbet",
    descr: "Podívejte se na výhody, které vám přináší naše mobilní aplikace.",
    fullText:
      "Mobilní aplikace doxxbet.cz je navržena tak, aby vám poskytla nejlepší herní zážitek.\n" +
      "Snadná instalace a uživatelsky přívětivé rozhraní zaručují pohodlí.\n" +
      "Aplikace umožňuje rychlý přístup k oblíbeným hrám a sportovnímu sázení.\n" +
      "Využijte exkluzivní bonusy dostupné pouze v aplikaci.\n" +
      "Funkce živých notifikací vás udrží informované o aktuálních nabídkách a zápasech.\n" +
      "Bezpečnostní opatření chrání vaše data a finanční transakce.\n" +
      "Optimalizace pro rychlost a stabilitu zajišťuje plynulý chod aplikace.\n" +
      "Stáhněte si ji ještě dnes a objevte zábavu, která vás čeká na doxxbet.cz.",
  },
  {
    id: 4,
    date: "2024-12-28",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Jak funguje hra Aviator",
    descr:
      "Získejte přehled o pravidlech a strategiích hry Aviator na doxxbet.cz.",
    fullText:
      "Aviator je jednoduchá, ale vzrušující hra, která přináší nový rozměr do online kasin.\n" +
      "Hra začíná vzlétnutím letadla, kdy roste násobitel vaší sázky.\n" +
      "Vaším cílem je kliknout na „cashout“ dříve, než letadlo zmizí.\n" +
      "Strategické plánování je klíčové pro maximalizaci výher.\n" +
      "Doxxbet nabízí detailní statistiky, které vám pomohou sledovat trendy.\n" +
      "Bonusové nabídky pro Aviator vám přidávají další šance na výhru.\n" +
      "Hra je dostupná na všech zařízeních, včetně mobilů a tabletů.\n" +
      "Vyzkoušejte Aviator na doxxbet.cz a zažijte jedinečný adrenalinový zážitek.",
  },
  {
    id: 5,
    date: "2024-12-20",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Vše, co potřebujete vědět o bonusech na doxxbet.cz",
    descr:
      "Zjistěte, jak využít bonusy na maximum a zvýšit své šance na výhru.",
    fullText:
      "Bonusy na doxxbet.cz jsou navrženy tak, aby zlepšily váš herní zážitek.\n" +
      "Uvítací bonusy vám umožní začít s extra kreditem.\n" +
      "Speciální akce, jako jsou cashback bonusy, chrání vaše finance.\n" +
      "Věrnostní programy odměňují pravidelné hráče.\n" +
      "Bonusy za vklad přidávají hodnotu k vašim finančním prostředkům.\n" +
      "Promo akce během svátků a speciálních událostí zvyšují vaše šance na výhru.\n" +
      "Sledujte náš blog pro nejnovější informace o aktuálních nabídkách.\n" +
      "Využijte našich nástrojů pro správu bonusů a hrajte zodpovědně.\n" +
      "Na doxxbet.cz vás čeká zábava, výhry a nezapomenutelný herní zážitek.",
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo") || img.closest(".santaBonus")) return;

      img.onclick = () => window.location.assign(ownLink);
    });
  }
});
